import { VcsProvider } from "types/generated";

export const getCommmitDigitsCount = (provider: VcsProvider) => {
  return provider === VcsProvider.Gitlab ? 8 : 7;
};
